import React from 'react'

function SearchOption(props) {
    return (
        <div>
            {props.type === 'sort' && (
                <div className="filter-wrap">
                    <span className="search-bar__span">SORT BY:</span>
                    <select className="search-bar__select" name="sort">
                        <option value="date">LATEST</option>
                        <option value="relevance">RELEVANCE</option>
                    </select>
                    <div className="dropdown-wrap" onClick={props.expand}>
                        <div className="sort-dropdown dropdown-filter">
                            <div
                                className="dropdown-option is-selected"
                                data-value="date"
                                data-name="sort"
                            >
                                LATEST
                            </div>
                            <div
                                className="dropdown-option"
                                data-value="relevance"
                                data-name="sort"
                            >
                                RELEVANCE
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {props.type === 'filter' && (
                <div className="filter-wrap">
                    <span className="search-bar__span">CONTENT TYPE:</span>
                    <select className="search-bar__select" name="filter">
                        <option value="">ALL</option>
                        <option value="bc-video">VIDEOS</option>
                        <option value="sn-article">ARTICLES</option>
                        <option value="sn-audio">AUDIO CLIPS</option>
                        <option value="sn-longform">LONG FORM ARTICLES</option>
                    </select>
                    <div className="dropdown-wrap" onClick={props.expand}>
                        <div className="sort-dropdown dropdown-filter">
                            <div
                                className="dropdown-option is-selected"
                                data-value=""
                                data-name="filter"
                            >
                                ALL
                            </div>
                            <div
                                className="dropdown-option"
                                data-value="bc-video"
                                data-name="filter"
                            >
                                VIDEOS
                            </div>
                            <div
                                className="dropdown-option"
                                data-value="sn-article"
                                data-name="filter"
                            >
                                ARTICLES
                            </div>
                            <div
                                className="dropdown-option"
                                data-value="sn-audio"
                                data-name="filter"
                            >
                                AUDIO CLIPS
                            </div>
                            <div
                                className="dropdown-option"
                                data-value="sn-longform"
                                data-name="filter"
                            >
                                LONG FORM ARTICLES
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
export default SearchOption
